import { MBIconV2Name } from '@shared/components/image';
import { API } from '@shared/types/api';
import { AuditTagComponent } from '../../config';
import { FieldOption } from './FieldOption';

export class AuditTagFieldOption implements FieldOption {
  constructor(
    readonly title: string,
    readonly icon: MBIconV2Name,
    readonly component: Partial<AuditTagComponent>,
  ) {}

  matchesComponent(component: API.AnyComponent, reservedIds: Array<string>): boolean {
    const isReserved = !!reservedIds.find(id => id === component.id);
    return (
      !isReserved &&
      component.type === 'AUDIT_TAG' &&
      !!(component as AuditTagComponent).multiselect === !!this.component.multiselect
    );
  }

  canBeAdded(_components: API.AnyComponent[]): boolean {
    return true;
  }
}
